import DeviceManager from "../DeviceManager";
import {Network} from "@/utils/Network";

export default class AWSDeviceManager extends DeviceManager {
  constructor(context, settings) {
    super();
    this.context = context;
    this.network = new Network(settings.http.noHttps);
  }

  EnableAppCommunication() {
    let requestDescriptor = this.context.networkRequestGenerator.EnableAppCommunication();
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  async StartListenRealtimeData(onCloseCallback, onMessageCallback) {
    let descriptors = this.context.networkRequestGenerator.StartListenRealtimeData();
    return new Promise(async (resolve) => {
      let messageDeserialize = null;
      for (let i in descriptors) {
        if (descriptors[i].method == "SUBSCRIBE")
          messageDeserialize = descriptors[i].deserializer;
        let p = new Promise((resolve) => {
          this.network
            .SendRequest(descriptors[i])
            .then((data) => resolve(data));
        });
        await p;
      }
      this.network.eventBus.$on("closed", () => onCloseCallback());
      this.network.eventBus.$on("message", (message) => {
        onMessageCallback(messageDeserialize(message));
      });
      resolve();
    });
  }

  StopListenRealtimeData() {
    let requestDescriptor = this.context.networkRequestGenerator.StopListenRealtimeData();
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => {
          this.network.eventBus.$off("closed");
          this.network.eventBus.$off("message");
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }

  RegisterDevice(device) {
    let device_id = null;
    for (let i in device)
      if (i.includes("id--") && device[i]) {
        device_id = device[i];
        break;
      }
    device.device_id = device_id;
    let requestDescriptor = this.context.networkRequestGenerator.AddDevice(
      device
    );
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => {
          if (data)
            resolve({
              name: device_id,
              credentials: data,
              isAvailable: true,
            });
          else resolve();
        })
        .catch((err) => reject(err));
    });
  }

  ListDevices() {
    let requestDescriptor = this.context.networkRequestGenerator.GetDevices();
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  //UpdateConfiguration(deviceId,gatewayId,configuration){
  UpdateConfiguration(deviceId, sharedWithArray) {
    console.log("configuration", sharedWithArray);
    let requestDescriptor = this.context.networkRequestGenerator.UpdateDeviceConfiguration(
      deviceId,
      sharedWithArray
    );
    console.log(requestDescriptor);
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
    /*
        gatewayId
        let requestDescriptor = this.context.networkRequestGenerator.UpdateDeviceConfiguration(deviceId,configuration)
        return new Promise(
            (resolve,reject)=>{
                this.network.SendRequest(requestDescriptor)
                .then((data)=>resolve(data))
                .catch((err)=>reject(err))
            }
        )      
        */
  }

  Control(deviceId, gatewayId, controlName, payload) {
    gatewayId;

    let requestDescriptor = this.context.networkRequestGenerator.ControlDevice(
      deviceId,
      controlName,
      payload
    );
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  Fota(deviceId, gatewayId, firmware) {
    gatewayId;

    let requestDescriptor = this.context.networkRequestGenerator.Fota(
      deviceId,
      firmware
    );
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  DeleteDevice(deviceId) {
    let requestDescriptor = this.context.networkRequestGenerator.DeleteDevice(
      deviceId
    );
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  ListFirmwares() {
    let requestDescriptor = this.context.networkRequestGenerator.GetFirmwares();
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  UploadFirmware(firmware) {
    let requestDescriptor = this.context.networkRequestGenerator.UploadFirmware(
      firmware.name,
      firmware.file
    );
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  RemoveFirmwares(firmwaresName) {
    let promises = [];
    firmwaresName.forEach(
      function(name) {
        let requestDescriptor = this.context.networkRequestGenerator.DeleteFirmware(
          name
        );
        promises.push(
          new Promise((resolve, reject) => {
            this.network
              .SendRequest(requestDescriptor)
              .then(() => resolve(name))
              .catch((err) => reject(err));
          })
        );
      }.bind(this)
    );
    return Promise.all(promises);
  }

  GetRawData(deviceIds, startTime, endTime) {
    let requestDescriptors = deviceIds.map((deviceId) =>
      this.context.networkRequestGenerator.GetData(
        [deviceId],
        startTime.getTime(),
        endTime.getTime(),
        "raw"
      )
    );
    return this.network.SendRequest(requestDescriptors[0]);
  }

  GetTelemetry(deviceIds, startTime, endTime) {
    let requestDescriptors = deviceIds.map((deviceId) =>
      this.context.networkRequestGenerator.GetData(
        [deviceId],
        startTime.getTime(),
        endTime.getTime(),
        "telemetry"
      )
    );
    return Promise.all(
      requestDescriptors.map(
        (requestDescriptor) =>
          new Promise((resolve, reject) => {
            this.network
              .SendRequest(requestDescriptor)
              .then((data) => resolve(data[0]))
              .catch((err) => reject(err));
          })
      )
    );
  }

  async GetGeoLocations(deviceIds, startTime, endTime) {
    let requestDescriptors = deviceIds.map((deviceId) =>
      this.context.networkRequestGenerator.GetData(
        [deviceId],
        startTime.getTime(),
        endTime.getTime(),
        "geolocation"
      )
    );

    let results = await Promise.all(
      requestDescriptors.map(
        (requestDescriptor) =>
          new Promise((resolve, reject) => {
            this.network
              .SendRequest(requestDescriptor)
              .then((data) => resolve(data))
              .catch((err) => reject(err));
          })
      )
    );
    return results.reduce(
      (concatenatedArray, array) => concatenatedArray.concat(array),
      []
    );
    // let requestDescriptor =
    //     this
    //         .context
    //         .networkRequestGenerator
    //         .GetTelemetry(deviceIds,startTime.getTime(),endTime.getTime())
    // return new Promise(
    //     (resolve,reject)=>{
    //         this.network.SendRequest(requestDescriptor)
    //         .then((data)=>resolve(data))
    //         .catch((err)=>reject(err))
    //     }
    // )
  }

  GetEvents(deviceIds, startTime, endTime) {
    let requestDescriptors = deviceIds.map((deviceId) =>
      this.context.networkRequestGenerator.GetData(
        [deviceId],
        startTime.getTime(),
        endTime.getTime(),
        "events"
      )
    );
    return new Promise(async (resolve) => {
      let results = await Promise.all(
        requestDescriptors.map(
          (requestDescriptor) =>
            new Promise((resolve, reject) => {
              this.network
                .SendRequest(requestDescriptor)
                .then((data) => resolve(data))
                .catch((err) => reject(err));
            })
        )
      );
      resolve(results.map((r) => r[0]));
    });

    // let requestDescriptor =
    //     this
    //         .context
    //         .networkRequestGenerator
    //         .GetTelemetry(deviceIds,startTime.getTime(),endTime.getTime())
    // return new Promise(
    //     (resolve,reject)=>{
    //         this.network.SendRequest(requestDescriptor)
    //         .then((data)=>resolve(data))
    //         .catch((err)=>reject(err))
    //     }
    // )
  }

  ListApiKeys() {
    let requestDescriptor = this.context.networkRequestGenerator.GetApiKeys();
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  CreateApiKey(apiKey) {
    let requestDescriptor = this.context.networkRequestGenerator.AddApiKey(
      apiKey
    );
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  UpdateApiKey(apiKey) {
    let requestDescriptor = this.context.networkRequestGenerator.UpdateApiKey(
      apiKey
    );
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  DeleteApiKey(apiKey) {
    let requestDescriptor = this.context.networkRequestGenerator.DeleteApiKey(
      apiKey
    );
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  CreatePerimeter(perimeter) {
    // window.console.log("function createPerimeter called", perimeter)
    let requestDescriptor = this.context.networkRequestGenerator.CreatePerimeter(
      perimeter
    );
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  async FetchPerimeters(devices) {
    // window.console.log("function fetchPerimeters called", devices)
    let requestDescriptors = devices.map((device) =>
      this.context.networkRequestGenerator.GetPerimeter(device.id)
    );

    let results = await Promise.all(
      requestDescriptors.map(
        (requestDescriptor) =>
          new Promise((resolve, reject) => {
            this.network
              .SendRequest(requestDescriptor)
              .then((data) => resolve(data))
              .catch((err) => reject(err));
          })
      )
    );
    // window.console.log(results);
    return results;
  }

  ListDataConverters() {
    let requestDescriptor = this.context.networkRequestGenerator.GetDataConverters();

    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  ListDeviceProfiles() {
    let requestDescriptor1 = this.context.networkRequestGenerator.GetDeviceProfiles();
    let requestDescriptor2 = this.context.networkRequestGenerator.GetDeviceProfiles(
      true
    );
    return new Promise(async (resolve, reject) => {
      try {
        let deviceProfiles = await this.network.SendRequest(requestDescriptor1);
        let defaultDeviceProfiles = await this.network.SendRequest(
          requestDescriptor2
        );
        resolve(deviceProfiles.concat(defaultDeviceProfiles));
      } catch (error) {
        reject(error);
      }
    });
  }

  CreateDeviceProfile(deviceProfile) {
    let requestDescriptor = this.context.networkRequestGenerator.AddDeviceProfile(
      deviceProfile
    );
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  DeleteDeviceProfile(deviceProfile) {
    let requestDescriptor = this.context.networkRequestGenerator.DeleteDeviceProfile(
      deviceProfile
    );
    return new Promise((resolve, reject) => {
      this.network
        .SendRequest(requestDescriptor)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }
}
